<template>
    <i class="text-dark ni ni-money-coins" aria-hidden="true"></i>
</template>
<script></script>